<template>
  <div class="shoppinglist-container" id="shoppinglistContainer" role="dialog" aria-labelledby="merklisteTitle" aria-modal="true">
    <div class="bg" v-on:click.prevent="close"></div>
    <div class="content" ref="content">
      <CloseButton ref="closeButton" @close="close" />

      <div class="details">
        <h3 aria-label="Deine Merkliste" id="merklisteTitle">
          {{
            $l("listHeadline")
          }}
        </h3>

        <div class="empty-container" v-if="listEmpty">
          <img src="/assets/images/empty-list.png" alt="Merkliste leer">
          <h4>Deine Merkliste ist noch leer</h4>
          <p>
            Durchstöbere jetzt unser Feuerwerkssortiment und stelle deine
            persönliche Merkliste zusammen.
          </p>
          <button v-on:click.prevent="jumpToList" class="button-primary">
            Zum Feuerwerkssortiment
          </button>
        </div>

        <MarketInfosBox v-if="market && !listEmpty" />

        <div class="no-market-hint" v-if="!listEmpty">
          Verkauf nur solange der Vorrat reicht.
        </div>

        <ShoppinglistItems :items="shoppinglistItems" @close="close" />
      </div>

      <ShoppinglistShare v-if="!listEmpty" />

      <FooterComponent :border="false" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import CloseButton from "@/components/CloseButton.vue";
import MarketInfosBox from "@/components/MarketInfosBox.vue";
import ShoppinglistItems from "@/components/ShoppinglistItems";
import ShoppinglistShare from "@/components/ShoppinglistShare";
import FooterComponent from "@/components/Footer";
export default {
  name: "product",
  components: {
    CloseButton,
    MarketInfosBox,
    ShoppinglistItems,
    ShoppinglistShare,
    FooterComponent
  },
  data() {
    return {
      productNr: false
    };
  },
  created() {},
  mounted() {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
    this.$refs.closeButton && this.$refs.closeButton.$el.focus();
  },
  methods: {
    jumpToList() {
      this.close();
      if (this.$route.name !== "home" && this.$route.name !== "homeMarket") {
        this.$router.push({ name: "home" });
      }
      window.setTimeout(() => {
        this.$store.commit("SET_JUMPTOLIST", true);
      }, 200);
    },
    close() {
      this.$trackPreviousPageView();
      this.$store.commit("SET_SHOW_SHOPPINGLIST", false);
    }
  },
  computed: {
    ...mapGetters(["products", "shoppinglistItems"]),
    ...mapState(["market"]),
    currentYear() {
      return moment().format("Y");
    },
    listEmpty() {
      return this.shoppinglistItems.length === 0;
    }
  }
};
</script>

<style lang="scss">
@import "./ShoppinglistOverlay";
</style>
